var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nav',{staticClass:"level"},_vm._l((_vm.items),function(item){return _c('div',{key:item.label,staticClass:"level-item has-text-centered"},[_c('div',[_c('p',{staticClass:"heading has-text-light"},[_vm._v(_vm._s(item.label))]),_c('p',{staticClass:"title has-text-white"},[_vm._v(_vm._s(item.value))])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }